/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BlogManagerShowArticleResponse } from './BlogManagerShowArticleResponse';

export type BlogManagerShowArticleResponseApiRespoonse = {
    data?: BlogManagerShowArticleResponse;
    status?: BlogManagerShowArticleResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace BlogManagerShowArticleResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

